import React, {Component} from 'react';
import {isEmpty, formatNumber} from "../../inc/Helpers";
import {Row, Col} from "reactstrap";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faMale,} from '@fortawesome/pro-solid-svg-icons/faMale';
import {faFemale} from '@fortawesome/pro-solid-svg-icons/faFemale';
import axios from "axios";
import {Doughnut} from 'react-chartjs-2';
import { defaults } from 'react-chartjs-2';
import LangContext from "../../providers/LangContext";

class CbsData extends Component {

	static contextType = LangContext;

	constructor(props) {
		super(props);

		const csrf = document.head.querySelector('meta[name="csrf-token"]');

		axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
		axios.defaults.headers.common['X-CSRF-TOKEN'] = csrf.content;
		axios.defaults.headers.common['X-localization'] = document.documentElement.lang;

		this.state = {
			general: {},
			buurt: {},
			stad: {},
			afstandHuisArts: '',
			afstandKinderdagverblijf: '',
			afstandSchool: '',
			afstandSupermarkt: '',
            hasErrors: false,
		};

		this.calcPercentage = this.calcPercentage.bind(this);
		this.getGraphOptions = this.getGraphOptions.bind(this);

		// Global defaults for Chartjs2
		defaults.global.legend.position = "bottom";
		defaults.global.defaultFontColor = (this.props.theme === 'new' || this.props.theme === 'era') ? '#666' : '#fff';
	}

	componentDidMount() {
		let self = this;
		axios.get('/api/site/' + this.props.siteID + '/cbs')
			.then((response) => {
				self.setState({
					general: response.data.general,
					buurt: response.data.buurt,
					stad: response.data.stad,
					afstandHuisArts: response.data.afstandHuisArts,
					afstandKinderdagverblijf: response.data.afstandKinderdagverblijf,
					afstandSchool: response.data.afstandSchool,
					afstandSupermarkt: response.data.afstandSupermarkt,
				});
			})
			.catch((error) => {
				this.setState({
                    hasErrors: true
                })
			});
	}

	calcPercentage(total, piece) {
		const result = piece / total * 100;
		return Math.round(result);
	}

	getGraphOptions = (title) => {
		return {
			title: {
				display: true,
				text: title
			},
			responsive: true,
			cutoutPercentage: 50,
			legend: {
				position: "bottom",
				labels: {
					fontSize: 14,
				}
			}
		}
	}

	render() {
        if(this.state.hasErrors) {
            return '';
        }

	    if (isEmpty(this.state.general)) {
			return (
				<p>Loading...</p>
			);
		}

		let lang = this.context.lang;

		const doughNutOptions = {
			responsive: true,
			cutoutPercentage: 50,
			legend: {
				display: true,
				position: "bottom",
				labels: {
					fontSize: 14,
				}
			},
		};

		const gezinnenBuurt = {
			labels: ["% " + lang.get('sites.with_children'), "% " + lang.get('sites.without_children'), "% " + lang.get('sites.single_households')],
			datasets: [{
				label: "Verdeling huishoudens",
				data: [this.state.buurt.huishMetKids, this.state.buurt.huishZonderKids, this.state.buurt.eenpersHuishoudens],
				backgroundColor: ["#1abc9c", "#27ae60", "#f1c40f"],
				borderColor: ["#1abc9c", "#27ae60", "#f1c40f"],

			}],
			options: this.getGraphOptions("Verdeling huishoudens")
		};

		const leeftijdBuurt = {
			labels: ["0 - 15", "15 - 25", "25 - 45", "45 - 65", "65+"],
			datasets: [{
				label: lang.get('sites.age_local_residents').toUpperCase(),
				data: [
					this.calcPercentage(this.state.buurt.buurtTotal, this.state.buurt.leeftijden.bew0_15),
					this.calcPercentage(this.state.buurt.buurtTotal, this.state.buurt.leeftijden.bew15_25),
					this.calcPercentage(this.state.buurt.buurtTotal, this.state.buurt.leeftijden.bew25_45),
					this.calcPercentage(this.state.buurt.buurtTotal, this.state.buurt.leeftijden.bew45_65),
					this.calcPercentage(this.state.buurt.buurtTotal, this.state.buurt.leeftijden.bew65),
				],
				backgroundColor: ["#1abc9c","#27ae60", "#f1c40f", "#e67e22", "#bdc3c7" ],
				borderColor: ["#1abc9c","#27ae60", "#f1c40f", "#e67e22", "#bdc3c7" ]
			}],
			options: doughNutOptions
		};

		const leeftijdStad = {
			labels: ["0 - 15", "15 - 25", "25 - 45", "45 - 65", "65+"],
			datasets: [{
				label: lang.get('sites.ages_in').toUpperCase() + " " + this.state.stad.cityName,
				data: [
					this.state.stad.leeftijden.bew0_15_stad,
					this.state.stad.leeftijden.bew15_25_stad,
					this.state.stad.leeftijden.bew25_45_stad,
					this.state.stad.leeftijden.bew45_65_stad,
					this.state.stad.leeftijden.bew65_stad,
				],
				backgroundColor: ["#1abc9c","#27ae60", "#f1c40f", "#e67e22", "#bdc3c7" ],
				borderColor: ["#1abc9c","#27ae60", "#f1c40f", "#e67e22", "#bdc3c7" ]
			}],
			options: doughNutOptions,
		};

		return (
			<div className="inDeBuurt-content">
				<h1 className="text-center">{lang.get('sites.neighborhood_statistics')}</h1>
				<h3 className="text-center sub_title" dangerouslySetInnerHTML={{ __html: lang.get('sites.neighborhood_statistics_subtitle', {zipcode: this.state.general.zipCode, residents_zipcode: this.state.buurt.buurtTotal, municipality: this.state.general.gemeenteNaam, residents_municipality: this.state.general.aantalInwoners }).toUpperCase()}} />
				<Row className="mt-3">
					<Col lg={6} className="text-center">
						<Row>
							<Col lg={12} className="text-center">
								<h3>{lang.get('sites.neighborhood')}</h3>
							</Col>
							<Col xs={6} lg={6} className="text-center">
								<FontAwesomeIcon size="5x" icon={faFemale} color="#e74c3c"/>
								<p>{formatNumber(this.state.buurt.vrouwenBuurt)} ({this.state.buurt.percentageVrouwen}%)</p>
							</Col>
							<Col xs={6} lg={6} className="text-center">
								<FontAwesomeIcon size="5x" icon={faMale} color="#3498db"/>
								<p>{formatNumber(this.state.buurt.mannenBuurt)} ({this.state.buurt.percentageMannen}%)</p>
							</Col>
						</Row>
						<Row>
							<Col lg={12} className="text-center">
								<h3>{this.state.general.gemeenteNaam}</h3>
							</Col>
							<Col xs={6} lg={6} className="text-center">
								<FontAwesomeIcon size="5x" icon={faFemale} color="#e74c3c"/>
								<p>{formatNumber(this.state.stad.vrouwen)} ({this.state.stad.percentageVrouwen}%)</p>
							</Col>
							<Col xs={6} lg={6} className="text-center">
								<FontAwesomeIcon size="5x" icon={faMale} color="#3498db"/>
								<p>{formatNumber(this.state.stad.mannen)} ({this.state.stad.percentageMannen}%)</p>
							</Col>
						</Row>
					</Col>
					<Col lg={6} className="text-center">
						<h3>{lang.get('sites.family_composition_neighborhood')}</h3>
						<Doughnut data={gezinnenBuurt}/>
					</Col>
				</Row>
				<Row className="mt-4">
					<Col lg={6} className="text-center">
						<h3>{lang.get('sites.age_local_residents')} (%)</h3>
						<Doughnut data={leeftijdBuurt}/>
					</Col>
					<Col lg={6} className="text-center">
						<h3>{lang.get('sites.ages_in')} {this.state.general.gemeenteNaam} (%)</h3>
						<Doughnut data={leeftijdStad}/>
					</Col>
				</Row>
				<Row className="mt-4">
					<Col xs={6} lg={6} className="text-center">
						<p><span className="indebuurt-ico icon-huisarts"></span></p>
                        <p className="indebuurt-icon-text"><strong>{lang.get('sites.the_doctor')}</strong></p>
						<p className="indebuurt-icon-text">{this.state.afstandHuisArts} {lang.get('sites.minutes_walk')}</p>
					</Col>
					<Col xs={6} lg={6} className="text-center">
						<p><span className="indebuurt-ico icon-school"></span></p>
                        <p className="indebuurt-icon-text"><strong>{lang.get('sites.the_school')}</strong></p>
						<p className="indebuurt-icon-text">{this.state.afstandSchool} {lang.get('sites.minutes_walk')}</p>
					</Col>
				</Row>
				<Row className="mt-4">
					<Col xs={6} lg={6} className="text-center">
						<p><span className="indebuurt-ico icon-kinderdagverblijf"></span></p>
                        <p className="indebuurt-icon-text"><strong>{lang.get('sites.the_daycare_centre')}</strong></p>
						<p className="indebuurt-icon-text">{this.state.afstandKinderdagverblijf} {lang.get('sites.minutes_walk')}</p>
					</Col>
					<Col xs={6} lg={6} className="text-center">
						<p><span className="indebuurt-ico icon-supermarkt"></span></p>
                        <p className="indebuurt-icon-text"><strong>{lang.get('sites.the_supermarket')}</strong></p>
						<p className="indebuurt-icon-text">{this.state.afstandSupermarkt} {lang.get('sites.minutes_walk')}</p>
					</Col>
					<Col sm={12} className="text-center">
						<p className="small"><sup>*</sup> {lang.get('sites.walking_distances_explanation')}</p>
					</Col>
				</Row>
			</div>
		)
	}
}

export default CbsData;
